import { createContext } from "react";
export const TotalAmountContext = createContext({
  unsuccessfulTotal: 0,
  overdueTotal: 0,
  unpaidOrderTotal: 0,
});